import React from 'react';
import { FormattedMessage } from 'react-intl';


//компонент меню для роли пользователя (включая неавторизованного), содержащий ссылки с правой стороны
const UserMenu = ({data, handleMenuClose, openClaim}) => {
    return ( 
        <div className='Menu__list'>
            <a href='/lots' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.auctions' />
            </a>
            {!data.hideArt ? 
            <a href='/arts' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.arts' />
            </a>
            : null}
            <a href='/fixedpricelots' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.fixedprices' />
            </a>
            <a href='/funds' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.foundations' />
            </a>
            <a href='/members' onClick={handleMenuClose}className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.participants' />
            </a>
            <a href='/aboutus' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.aboutus' />
            </a>
            <a href='/help' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='support.project' />
            </a>
            <button className='Menu__link Link Head Link_single Link_light' onClick={openClaim} >
                <FormattedMessage id='header.become_participant' />
            </button>
        </div>
    )
}

export default UserMenu;


// WEBPACK FOOTER //
// ./src/components/MenuComponents/mobileMenu/MenuListUser.jsx